import { Container as MuiContainer, type ContainerProps as MuiContainerProps } from '@mui/material';
import type { FC } from 'react';

export type ContainerProps = MuiContainerProps;

export const Container: FC<ContainerProps> = (props) => {
  return <MuiContainer sx={{ px: { sm: 2, md: 4, lg: 6 } }} {...props} />;
};
